import { render } from "./InvitePeople.vue?vue&type=template&id=2ec917f8"
import script from "./InvitePeople.vue?vue&type=script&lang=js"
export * from "./InvitePeople.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__